<div class="hint">
  {{ hint }}
</div>
@if (question.type === questionType.MultipleChoice) {
<div>
  @for (answer of question.answers; track questionAnswer($index, answer)) {
  <mat-checkbox
    (ngModelChange)="updateSelection(answer.id, $event)"
    [disabled]="disabled"
    [ngModel]="isAnswerSelected(answer.id)"
    #checkbox
    class="answer {{
      showCorrectAnswers
        ? (answer.is_right && !question.is_poll_question) ||
          (question.is_poll_question && isAnswerSelected(answer.id))
          ? 'correct'
          : 'incorrect'
        : ''
    }}"
    [ngClass]="{
      'poll-answer': question?.is_poll_question
    }"
    color="primary"
  >
    <div
      [matRippleTrigger]="ripple.closest('.mat-checkbox')"
      #ripple
      matRipple
    ></div>
    <qa-markdown-katex [data]="answer.text"> </qa-markdown-katex>
    @if (showCorrectAnswers && !question.is_poll_question) {
    <div class="answerflare">
      @if (!isAnswerSelected(answer.id) && answer.is_right) {
      <mat-label>
        {{ 'question.label.answerMissing' | translate }}
      </mat-label>
      } @if (isAnswerSelected(answer.id) && !answer.is_right) {
      <mat-label>
        {{ 'question.label.answerWrong' | translate }}
      </mat-label>
      } @if (isAnswerSelected(answer.id) && answer.is_right) {
      <mat-label>
        {{ 'question.label.rightAnswer' | translate }}
      </mat-label>
      } @if ( (isAnswerSelected(answer.id) && answer.is_right) ||
      (!isAnswerSelected(answer.id) && !answer.is_right) ) {
      <mat-icon> done </mat-icon>
      } @if ( (!isAnswerSelected(answer.id) && answer.is_right) ||
      (isAnswerSelected(answer.id) && !answer.is_right) ) {
      <mat-icon> clear </mat-icon>
      }
    </div>
    }
  </mat-checkbox>
  }
</div>
} @if (question.type !== questionType.MultipleChoice) {
<mat-radio-group
  (ngModelChange)="updateSelection($event)"
  [ngModel]="control?.value"
>
  @for (aSingleChoiceAnswer of singleChoiceAnswers; track
  aSingleChoiceAnswer.value) {
  <mat-radio-button
    [disabled]="disabled"
    [value]="aSingleChoiceAnswer.value"
    #radioButton
    data-cy="optionRadioBtn"
    class="answer {{
      showCorrectAnswers
        ? (aSingleChoiceAnswer.value == singleChoiceAnswer &&
            !question.is_poll_question) ||
          (question.is_poll_question &&
            control?.value === aSingleChoiceAnswer.value)
          ? 'correct'
          : 'incorrect'
        : ''
    }}"
    [ngClass]="{
      'poll-answer': question?.is_poll_question
    }"
    color="primary"
  >
    <div
      [matRippleTrigger]="ripple.closest('.mat-radio-button')"
      #ripple
      matRipple
    ></div>
    <qa-markdown-katex [data]="aSingleChoiceAnswer.text"> </qa-markdown-katex>
    @if (showCorrectAnswers && !question.is_poll_question) {
    <div class="answerflare">
      @if ( control?.value != aSingleChoiceAnswer.value &&
      aSingleChoiceAnswer.value == singleChoiceAnswer ) {
      <mat-label>
        {{ 'question.label.missingAnswer' | translate }}
      </mat-label>
      } @if ( control?.value == aSingleChoiceAnswer.value &&
      aSingleChoiceAnswer.value != singleChoiceAnswer ) {
      <mat-label>
        {{ 'question.label.wrongAnswer' | translate }}
      </mat-label>
      } @if ( control?.value == aSingleChoiceAnswer.value &&
      aSingleChoiceAnswer.value == singleChoiceAnswer ) {
      <mat-label>
        {{ 'question.label.rightAnswer' | translate }}
      </mat-label>
      } @if ( (aSingleChoiceAnswer.value == singleChoiceAnswer && control?.value
      == aSingleChoiceAnswer.value) || (aSingleChoiceAnswer.value !=
      singleChoiceAnswer && control?.value != aSingleChoiceAnswer.value) ) {
      <mat-icon> done </mat-icon>
      } @if ( !( (aSingleChoiceAnswer.value == singleChoiceAnswer &&
      control?.value == aSingleChoiceAnswer.value) || (aSingleChoiceAnswer.value
      != singleChoiceAnswer && control?.value != aSingleChoiceAnswer.value) ) )
      {
      <mat-icon> clear </mat-icon>
      }
    </div>
    }
  </mat-radio-button>
  }
</mat-radio-group>
}
